import React, { createElement, Fragment } from 'react'
import { Route } from 'react-router-dom'
import { BaseLayoutAppBar, BaseLayoutContent } from 'components/Layout/BaseLayout'
import Logo from 'components/Layout/Logo'

// Pages
import EmailVerifyPage from './EmailVerify'
import ManagerEmailVerifyPage from './ManagerEmailVerify'
import RequestVerifyPage from './RequestVerify'
import RequestAcceptPage from './RequestAccept'
import RequestRejectPage from './RequestReject'
import TokenLoginPage from './TokenLogin'
import ResetPasswordPage from './ResetPassword'
import LogoutPage from './Logout'

const wrapPage = page => routeProps => (
  <Fragment>
    <BaseLayoutAppBar>
      <Logo largeOnDesktop />
    </BaseLayoutAppBar>
    <BaseLayoutContent>
      { createElement(page, routeProps) }
    </BaseLayoutContent>
  </Fragment>
)

export default () => [
  { path: '/actions/email-verify/:token', component: EmailVerifyPage },
  { path: '/actions/manager-email-verify/:token', component: ManagerEmailVerifyPage },
  { path: '/actions/query-verify/:token', component: RequestVerifyPage },
  { path: '/actions/query-accept/:token', component: RequestAcceptPage },
  { path: '/actions/query-reject/:token', component: RequestRejectPage },
  { path: '/actions/login/:token', component: TokenLoginPage },
  { path: '/actions/reset-password/:token', component: ResetPasswordPage },
  { path: '/actions/logout', component: LogoutPage },
].map(route => (
  <Route key={route.path} path={route.path} exact render={wrapPage(route.component)} />
))
